import styled from 'styled-components';

export const FuturaTarjetaWrapper = styled.div`
.tituloTarifas {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 30px;
}

.contenedor-tarifas {
  display: grid;
}

.activeDrop ._15euW {
  background: rgba(0,161,223,0.1);
}

.p-info {
  width: 74%;
  line-height: 20px;
}

.contenido-Dropdown {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.tarifa-info b {
  display: block;
}

.cantidadUF {
  font-size: 18px;
}

.p-info p {
  font-size: 14px;
  margin-bottom: 35px;
}
.p-info b {
  font-size: 14px;
  margin-bottom: 1px;
}
.tarifa-info {
  font-size: 14px;
  margin-bottom: 7px;
  line-height: 20px;
}

._3sTov._35oaN._2xQhB {
  margin-bottom: 20px;
}
._3NSXd {
  color: #007db7;
}

@media (max-width: 768px) {
  .p-info {
      width: 80%;
  }
}

@media (max-width: 425px) {
  .contenedor-tarifas,
  .contenido-Dropdown {
      grid-template-columns: 1fr;
  }

  .texto-tarifas {
      margin-bottom: 0;
  }

  ._3g_Jc ._10WAf ._3NSXd {
      font-size: 0.8rem;
  }

  .p-info {
      width: 100%;
  }

  .p-info p {
      font-size: 0.8rem;
      margin-bottom: 30px;
      margin-top: 15px;
  }
  ._3pNgQ ._3b-4_ ._sqrUW {
      font-size: 1.125rem;
      line-height: 1.5;
  }
  .tarifa-info {
      font-size: 0.8rem;
      margin-bottom: 18px;
      line-height: 20px;
  }
}
@media (max-width: 375px) {
  .texto-tarifas {
      margin-bottom: 0;
  }
  .cantidadUF p {
    font-size: 1rem;
  }

  .contenedor-tarifas,
  .contenido-Dropdown {
      grid-template-columns: 1fr;
  }

  ._3g_Jc ._10WAf ._3NSXd {
      font-size: 0.7rem;
  }

  .p-info {
      width: 100%;
  }

  .p-info p {
      font-size: 0.785rem;
      margin-bottom: 35px;
  }
  .tarifa-info {
      font-size: 0.8rem;
      margin-bottom: 18px;
      line-height: 20px;
  }
  ._3pNgQ ._3b-4_ ._sqrUW {
      font-size: 1.125rem;
      line-height: 1.5;
  }
}
@media (max-width: 320px) {
  .contenedor-tarifas,
  .contenido-Dropdown {
      grid-template-columns: 1fr;
  }
  .texto-tarifas {
      margin-bottom: 0;
  }
  .p-info {
      width: 100%;
  }
  .p-info b {
      font-size: 0.8rem;
  }
  .p-info p {
      font-size: 0.785rem;
      margin-bottom: 37px;
  }
  .cantidadUF p {
      font-size: 1rem;
      margin-bottom: 14px;
      margin-top: 2px;
  }

  .tarifa-info {
      font-size: 0.8rem;
      margin-bottom: 18px;
      line-height: 20px;
  }
  ._3pNgQ ._3b-4_ ._sqrUW {
      font-size: 1.125rem;
      line-height: 1.5;
  }
  ._1xBf0 p {
      font-size: 0.8rem;
  }

  ._3g_Jc ._10WAf ._3NSXd {
      font-size: 0.7rem;
  }
}
`;

export default FuturaTarjetaWrapper;
